import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT } from "const"
import { MarkovTransition } from "server/models"
import {
    PRM_MARKOV_MODEL,
    StoreType,
    MarkovExpressionConvertToView,
    addModal,
} from "client/store"
import { hasAccess } from "client/utils"
import {
    Link,
    TableColumn,
} from "client/components"

import EditTransition from "client/pages/markov/transition/edit"

const Columns = () => {
    const stateList = useSelector((state: StoreType) => state.markovState.stateList)
    const variableList = useSelector((state: StoreType) => state.markovVariable.variableList)
    const calculatedExpressions = useSelector((state: StoreType) => state.markovTransition.calculatedExpressions)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editModelAccess = hasAccess(PRM_MARKOV_MODEL, EDIT)

    const transitionLink = (transition: MarkovTransition, linkContent: any) => (
        <Link
            href="/#"
            onClick={() => dispatch(addModal({
                key: "editModelTransition",
                content: <EditTransition transitionId={transition.id} />,
            }))}
        >
            {linkContent}
        </Link>
    )

    const columns: TableColumn[] = [
        {
            field: "stateFrom",
            header: lang.stateFrom,
            sortable: true,
            cellMinWidth: "200px",
            formatter: (transition: MarkovTransition) => {
                const state = stateList[transition.stateFrom]
                if (!state) return null
                return editModelAccess
                    ? transitionLink(transition, state.name)
                    : state.name
            },
        },
        {
            field: "stateTo",
            header: lang.stateTo,
            sortable: true,
            cellMinWidth: "200px",
            formatter: (transition: MarkovTransition) => {
                const state = stateList[transition.stateTo]
                if (!state) return null
                return editModelAccess
                    ? transitionLink(transition, state.name)
                    : state.name
            },
        },
        {
            field: "expression",
            header: lang.expression,
            sortable: true,
            cellMinWidth: "200px",
            formatter: (transition: MarkovTransition) => {
                const exp = MarkovExpressionConvertToView(transition.expression, variableList)
                return editModelAccess
                    ? transitionLink(transition, exp)
                    : exp
            },
        },
        {
            field: "calculatedValue",
            header: lang.value,
            cellMinWidth: "200px",
            formatter: (transition: MarkovTransition) => (
                calculatedExpressions[transition.id] !== undefined ? calculatedExpressions[transition.id] : null
            ),
        },
        {
            field: "order",
            header: lang.order,
            sortable: true,
            cellMinWidth: "100px",
        },
    ]

    if (editModelAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
